import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { canvasToFile } from "utils/constant";

export default function CropCoverSquare({
  setParentCrop = () => {},
  setCropPreview = () => {},
  locked = false,
  ...props
}) {
  const { image, type, returnType } = props;
  const imgSrc = image;
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const zoom = 1;
  const [aspect, setAspect] = useState(2.6); // Fixed aspect ratio: width:height = 2.6:1
  const [lock, setLock] = useState(locked);

  const getCropData = useCallback(async () => {
    if (completedCrop?.width && completedCrop?.height && imgRef.current) {
      const { blobImage, image, base64Canvas } = await canvasToFile(
        imgRef.current,
        completedCrop,
        zoom,
        0,
        "crop-image-free-mode",
        type
      );
      if (blobImage) {
        if (returnType === "blob") {
          setParentCrop(blobImage);
        } else {
          setParentCrop(image);
        }
        setCropPreview(base64Canvas);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completedCrop, zoom]);

  function onImageLoad(e) {
    const { width, height } = e.currentTarget;
    const targetAspect = 2.6; // enforce 2.6:1

    // Start with full width, derive height by aspect
    let cropWidth = width;
    let cropHeight = Math.round(cropWidth / targetAspect);

    // If height exceeds image height, fit by height instead
    if (cropHeight > height) {
      cropHeight = height;
      cropWidth = Math.round(cropHeight * targetAspect);
    }

    // Center the crop within the image
    const x = Math.round((width - cropWidth) / 2);
    const y = Math.round((height - cropHeight) / 2);

    setAspect(targetAspect);
    setCrop({ unit: "px", x, y, width: cropWidth, height: cropHeight });
  }

  useEffect(() => {
    getCropData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completedCrop]);

  return (
    <div className="w-full">
      <div
        className="w-full relative bg-passwordGray rounded-md flex justify-center items-center"
        style={{ minHeight: "400px" }}
      >
        <div
          className="w-full overflow-y-auto flex justify-center items-start"
          style={{ maxHeight: "73vh" }}
        >
          {!!imgSrc && (
            <ReactCrop
              crop={crop}
              onChange={(_, percentCrop) => setCrop(percentCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={aspect}
              locked={lock}
            >
              <img
                ref={imgRef}
                alt="Crop me"
                src={imgSrc}
                onLoad={onImageLoad}
                className="max-w-full"
              />
            </ReactCrop>
          )}
        </div>
      </div>
    </div>
  );
}
